import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';

// TSS vite/03 — combined clients + farms typeahead
// (GET /admin/clients/search, api-reference/admin-clients.md). Minimal-field
// lookup, no pagination; the server caps each array (`limit`, max 25).
// q < 2 chars → the endpoint returns empty arrays, so we gate the query.

export function useClientSearch(q, { scope = 'all', limit = 10 } = {}) {
    const term = (q || '').trim();
    return useQuery({
        queryKey: ['clients', 'search', term, scope, limit],
        queryFn:  ({ signal }) =>
            api.get('admin/clients/search', { params: { q: term, scope, limit }, signal }).then(r => r.data),
        enabled: term.length >= 2,
        placeholderData: (prev) => prev,
    });
}
